export const config = {
  getBaseUrl: () =>
    localStorage.getItem('chat-x_base_url') || 'https://api.coze.cn',
  getBaseWsUrl: () =>
    localStorage.getItem('chat-x_base_ws_url') || 'wss://ws.coze.cn',
  getPat: () => 'pat_iNVpXftJW95UP7SlxglBR9JbuCHKDH2ATCzmqT2fKy0PtZLV4nXbwsYymF5VNogD',
  getBotId: () => '7584712349077045294',
};
